import { useTranslation } from 'react-i18next';

import useAiChatToolLabel from '../../hooks/useAiChatToolLabel';
import useAiChatToolStatus from '../../hooks/useAiChatToolStatus';
import AiChatToolCard from '../AiChatToolCard';

import type { ReactElement } from 'react';
import type { IAiChatToolCallOf } from '../../interfaces/IAiChatToolCall';

/**
 * The `lookUpDocument` tool call: a search of the stored documents by title.
 *
 * Shows the query, and once the matches are in, how many there were — which says more than
 * "done". The matches themselves are not shown yet.
 */
function LookUpDocumentToolCall({ part }: IAiChatToolCallOf<'lookUpDocument'>): ReactElement {
  const { t } = useTranslation();
  const label = useAiChatToolLabel('lookUpDocument');
  const status = useAiChatToolStatus(part.state);

  const summary = part.state === 'output-available'
    ? t('aiChat.tools.documentsFound', { count: part.output.documents.length })
    : status;

  return (
    <AiChatToolCard name={label} status={summary} errorText={part.errorText}>
      {part.input?.query}
    </AiChatToolCard>
  );
}

export default LookUpDocumentToolCall;
